module.exports = __webpack_public_path__ + "static/media/test1_4.6a2f8b0f.png";